/* src/app/pages/project/map/repository/import-wizard/components/pending-list/import-wizard-pending-list.component.scss */
.pending-imports-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 90vh;
  padding: 1rem 1.5rem;
  gap: 1.2rem;
}
.modal-title {
  text-decoration: underline;
  text-decoration-thickness: 0.2rem;
  text-decoration-color: var(--color-primary);
  text-underline-offset: 0.3rem;
  font-weight: bold;
  text-transform: uppercase;
}
.filters-container {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.search-input-dimension {
  margin-bottom: 12px;
  max-width: 450px;
}
.search-input {
  margin: 0 !important;
}
.scope-tabs {
  display: flex;
  gap: 0.25rem;
  border-bottom: 1px solid rgba(255, 195, 0, 0.2);
  padding-bottom: 0.5rem;
}
.scope-tab {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: transparent;
  border: none;
  color: var(--color-text);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.35rem 0.75rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.scope-tab:hover {
  color: var(--color-primary);
  background: var(--color-bg-secondary);
}
.scope-tab.active {
  color: var(--color-primary);
  background: var(--color-bg-secondary);
}
.scope-tab.active .badge {
  background: var(--color-primary);
  color: #000;
}
.badge {
  background: rgba(255, 195, 0, 0.15);
  color: var(--color-primary);
  border-radius: 999px;
  padding: 0.1rem 0.45rem;
  font-size: 0.7rem;
  font-weight: bold;
  transition: all 0.2s ease;
}
.pending-imports-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  overflow-y: auto;
}
.empty-list {
  text-align: center;
  color: rgba(255, 196, 0, 0.6588235294);
  font-weight: bold;
}
.empty-state {
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 5rem 2rem;
}
.empty-state-icon {
  color: rgba(255, 255, 255, 0.15);
  margin-bottom: 1rem;
}
.empty-state-title {
  font-weight: 700;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text);
  margin-bottom: 0.25rem;
}
.empty-state-subtitle {
  font-size: 0.9rem;
  color: var(--color-text);
  text-align: center;
  max-width: 320px;
  line-height: 1.8;
}
@media screen and (max-width: 880px) {
  .pending-imports-list {
    grid-template-columns: repeat(1, 1fr);
  }
}
/*# sourceMappingURL=import-wizard-pending-list.component-DUMDHWXQ.css.map */
